import { lazy } from "react";

const Payroll_Dashboard = lazy(() => import("@/pages/Payroll/Dashboards/index"));

const Payroll_Employees = lazy(() => import("@/pages/Payroll/Employees/index"));
const Payroll_Employees_Loans = lazy(() => import("@/pages/Payroll/EmployeeLoans/index"));
const Payroll_Employees_Incomes = lazy(() => import("@/pages/Payroll/EmployeeIncomes/index"));
const Payroll_Employees_Deductions = lazy(() => import("@/pages/Payroll/DeductionSummary/index"));
const Payroll_BankTransmittals = lazy(() => import("@/pages/Payroll/BankTransmittals/index"));
const Payroll_Payouts = lazy(() => import("@/pages/Payroll/Payouts/index"));

const Payroll_Settings = lazy(() => import("@/pages/Payroll/StaticData/index"));
const Payroll_Settings_DeductionTypes = lazy(() => import("@/pages/Payroll/StaticData/DeductionTypes/index"));
const Payroll_Settings_IncomeTypes = lazy(() => import("@/pages/Payroll/StaticData/IncomeTypes/index"));
const Payroll_Settings_LoanTypes = lazy(() => import("@/pages/Payroll/StaticData/LoanTypes/index"));
const Payroll_Settings_PayrollGroups = lazy(() => import("@/pages/Payroll/StaticData/PayrollGroups/index"));
const Payroll_Settings_PayrollPeriods = lazy(() => import("@/pages/Payroll/StaticData/PayrollPeriods/index"));
const Payroll_Settings_BankConfigoration = lazy(() => import("@/pages/Payroll/StaticData/BankConfigurations/index"));
const Payroll_Reports = lazy(() => import("@/pages/Payroll/Reports/index"));

export var payrollRoutes = [
    { path: "/payroll/dashboard", component: <Payroll_Dashboard /> },

    { path: "/payroll/employees", component: <Payroll_Employees /> },
    { path: "/payroll/employees/loans", component: <Payroll_Employees_Loans /> },
    { path: "/payroll/employees/incomes", component: <Payroll_Employees_Incomes /> },
    { path: "/payroll/employees/deductions", component: <Payroll_Employees_Deductions /> },
    { path: "/payroll/bank-transmittals", component: <Payroll_BankTransmittals /> },
    { path: "/payroll/payrolls", component: <Payroll_Payouts /> },

    { path: "/payroll/settings", component: <Payroll_Settings /> },
    { path: "/payroll/settings/deductionTypes", component: <Payroll_Settings_DeductionTypes /> },
    { path: "/payroll/settings/incomeTypes", component: <Payroll_Settings_IncomeTypes /> },
    { path: "/payroll/settings/loantypes", component: <Payroll_Settings_LoanTypes /> },
    { path: "/payroll/settings/payrollGroups", component: <Payroll_Settings_PayrollGroups /> },
    { path: "/payroll/settings/payrollPeriods", component: <Payroll_Settings_PayrollPeriods /> },
    { path: "/payroll/settings/bankConfigurations", component: <Payroll_Settings_BankConfigoration /> },
    { path: "/payroll/reports", component: <Payroll_Reports /> },

];